<script setup lang="ts"></script>
<template>
  <div class="base-widget">
    <div class="title">
      <slot name="title"></slot>
    </div>
    <div class="body">
      <slot name="body"></slot>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<style lang="scss">
.base-widget {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(230, 230, 230, 0.8);
  border-radius: 8px;
  padding: 16px;
  margin: 10px;
  min-height: 200px;

  .title {
    color: $color-primary-darken;
    font-weight: bold;
    font-size: $medium-title;
  }

  .footer {
    display: flex;
    justify-content: end;
  }
}
</style>
